<script lang="ts">
  // Ported from fe/src/lib/components/ConfirmationModal.svelte
  // Dropped lucide dependency — uses an inline SVG warning icon instead so
  // the widget bundle doesn't pull an icon library.
  import { t } from '../i18n/index';

  let {
    title,
    message,
    onConfirm,
    onCancel,
  }: {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
  } = $props();
</script>

<div
  class="tashimoto-support-absolute tashimoto-support-inset-0 tashimoto-support-bg-black/40 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center tashimoto-support-z-50 tashimoto-support-backdrop-blur-sm"
  data-testid="confirmation-modal"
>
  <div
    class="tashimoto-support-bg-white tashimoto-support-rounded-xl tashimoto-support-shadow-2xl tashimoto-support-w-[85%] tashimoto-support-max-w-[320px] tashimoto-support-overflow-hidden"
  >
    <div class="tashimoto-support-px-6 tashimoto-support-pt-6 tashimoto-support-pb-4 tashimoto-support-text-center">
      <div
        class="tashimoto-support-mx-auto tashimoto-support-w-12 tashimoto-support-h-12 tashimoto-support-rounded-full tashimoto-support-bg-red-50 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center tashimoto-support-mb-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="tashimoto-support-text-red-500"
          aria-hidden="true"
        >
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </div>
      <h3 class="tashimoto-support-text-base tashimoto-support-font-semibold tashimoto-support-text-gray-900 tashimoto-support-mb-2">
        {title}
      </h3>
      <p class="tashimoto-support-text-sm tashimoto-support-text-gray-500 tashimoto-support-leading-relaxed">
        {message}
      </p>
    </div>

    <div class="tashimoto-support-px-6 tashimoto-support-pb-6 tashimoto-support-flex tashimoto-support-gap-3">
      <button
        type="button"
        class="tashimoto-support-flex-1 tashimoto-support-py-2.5 tashimoto-support-text-sm tashimoto-support-font-medium tashimoto-support-text-gray-700 tashimoto-support-bg-gray-100 hover:tashimoto-support-bg-gray-200 tashimoto-support-rounded-lg tashimoto-support-transition-colors"
        onclick={onCancel}
      >
        {t('common.cancel')}
      </button>
      <button
        type="button"
        class="tashimoto-support-flex-1 tashimoto-support-py-2.5 tashimoto-support-text-sm tashimoto-support-font-medium tashimoto-support-text-white tashimoto-support-bg-red-500 hover:tashimoto-support-bg-red-600 tashimoto-support-rounded-lg tashimoto-support-transition-colors tashimoto-support-shadow-sm"
        onclick={onConfirm}
      >
        {t('common.confirm')}
      </button>
    </div>
  </div>
</div>
